import React from 'react';
import { format } from 'date-fns';

const getHooperColor = (score) => {
  if (score <= 12) return '#22C55E';
  if (score <= 16) return '#3B82F6';
  if (score <= 20) return '#F59E0B';
  return '#EF4444';
};

const getHooperCategory = (score) => {
  if (score <= 12) return 'Excellent';
  if (score <= 16) return 'Good';
  if (score <= 20) return 'Fair';
  return 'Poor';
};

const WellnessHistoryTable = ({ wellnessHistory }) => {
  if (!wellnessHistory || wellnessHistory?.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '32px', color: '#64748B' }}>
        <p style={{ fontSize: '12px' }}>No wellness data available for this period</p>
      </div>
    );
  }

  return (
    <table style={{ 
      width: '100%', 
      borderCollapse: 'collapse',
      fontSize: '10px'
    }}>
      <thead>
        <tr style={{ backgroundColor: '#F1F5F9', borderBottom: '2px solid #E2E8F0' }}>
          <th style={{ padding: '8px', textAlign: 'left', fontWeight: '600' }}>Date</th>
          <th style={{ padding: '8px', textAlign: 'center', fontWeight: '600' }}>Sleep</th>
          <th style={{ padding: '8px', textAlign: 'center', fontWeight: '600' }}>Fatigue</th>
          <th style={{ padding: '8px', textAlign: 'center', fontWeight: '600' }}>Soreness</th>
          <th style={{ padding: '8px', textAlign: 'center', fontWeight: '600' }}>Stress</th>
          <th style={{ padding: '8px', textAlign: 'center', fontWeight: '600' }}>Hooper Index</th>
          <th style={{ padding: '8px', textAlign: 'center', fontWeight: '600' }}>Category</th>
        </tr>
      </thead>
      <tbody>
        {wellnessHistory?.map((entry, index) => {
          const hooperIndex = entry?.sleep + entry?.fatigue + entry?.soreness + entry?.stress;
          const category = getHooperCategory(hooperIndex);
          const color = getHooperColor(hooperIndex);
          
          return (
            <tr key={index} style={{ borderBottom: '1px solid #E2E8F0' }}>
              <td style={{ padding: '8px' }}>{format(new Date(entry.date), 'dd/MM/yyyy')}</td>
              <td style={{ padding: '8px', textAlign: 'center' }}>{entry?.sleep}/7</td>
              <td style={{ padding: '8px', textAlign: 'center' }}>{entry?.fatigue}/7</td>
              <td style={{ padding: '8px', textAlign: 'center' }}>{entry?.soreness}/7</td>
              <td style={{ padding: '8px', textAlign: 'center' }}>{entry?.stress}/7</td>
              <td style={{ padding: '8px', textAlign: 'center', fontWeight: '600' }}>{hooperIndex}/28</td>
              <td style={{ 
                padding: '8px', 
                textAlign: 'center',
                fontWeight: '500',
                color: color
              }}>
                {category}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default WellnessHistoryTable;